// Enter all your detials in this file
// Logo images
// import logogradient from "./assets/logo.svg";
import logo from "./assets/logo2.svg";
// Profile Image
import profile from "./assets/profile.png";
// Tech stack images
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
import Java from "./assets/techstack/Java.png";
import firebase from "./assets/techstack/firebase.png";
// Porject Images
import projectImage1 from "./assets/projects/project1.png";
import projectImage2 from "./assets/projects/project2.png";
import projectImage3 from "./assets/projects/project3.png";
import projectImage4 from "./assets/projects/project4.png";
import projectImage5 from "./assets/projects/project5.png";
import projectImage6 from "./assets/projects/project6.jpg";

// Logos
export const logos = {
  // logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Swaraj Anand",
  tagline: "I build things for web 🌍",
  img: profile,
  about: `I'm a passionate frontend developer with a strong foundation in React.js. Constantly seeking to push my boundaries, I'm currently learning the MERN stack to become a full-stack developer. My experience building interactive user interfaces, paired with my eagerness to learn backend technologies, fuels my drive to create robust web applications`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/swaraj-anand/",
  github: "https://github.com/SwarajAnand",
  twitter: "https://x.com/swaraj_anand__",
  instagram: "https://www.instagram.com/swaraj_anand___/",
};

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "MERN Stack Dev Bootcamp",
    Company: "Geekster",
    Location: "Online",
    Type: "Full Time",
    Duration: "Aug 2023 - Present",
  },
  {
    Position: "Bachelor in Computer Science",
    Company: `IIMT Engineering College`,
    Location: "Meerut",
    Type: "Full Time",
    Duration: "Aug 2019 - June 2023",
  },
  {
    Position: "XII Standard",
    Company: "VNS Narma",
    Location: "Bihar",
    Type: "Full Time",
    Duration: "April 2017 - April 2019",
  },
  {
    Position: "X Standard",
    Company: "Kid Z Public School",
    Location: "Bihar",
    Type: "Full Time",
    Duration: "March 2015 - March 2017",
  },
];

// Java.png

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  Java: Java,
  js: js,
  react: react,
  redux: redux,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
  firebase,
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "Backend Skill Enhancement",
    image: projectImage1,
    description:
      "This project showcases a comprehensive backend development skill set with MERN stack, focusing on building robust, scalable server-side applications and API integrations. Additionally, learned Redis basics and is used for caching to improve performance, and Docker is employed for containerization, ensuring a consistent development environment.",
    techstack: "Node, Express, MongoDB, Mongoose, Redis, Docker, JWT",
    previewLink: "https://github.com/SwarajAnand/BackendWithNodePrep",
    githubLink: "https://github.com/SwarajAnand/BackendWithNodePrep",
  },
  {
    "title": "FRONTEND - Netflix UI Clone",
    "image": projectImage2,
    "description": "A Netflix UI Clone built using React JS, JavaScript, Tailwind, MUI, Firebase, and Redux. This project replicates the visual design and layout of Netflix, showcasing frontend development skills and attention to detail.",
    "techstack": "React JS, JavaScript, Tailwind, MUI, Firebase, Redux",
    "previewLink": "https://netflix-gpt-six-swart.vercel.app/",
    "githubLink": "https://github.com/SwarajAnand/NetflixGpt"
  },
  {
    "title": "FRONTEND - Google Drive Clone",
    "image": projectImage3,
    "description": "A Google Drive Clone built using React JS, JavaScript, Tailwind, MUI, Firebase, and Redux. This project replicates the core features of Google Drive, including file upload, storage, and management, showcasing the power of modern web development technologies.",
    "techstack": "React JS, JavaScript, Tailwind, MUI, Firebase, Redux",
    "previewLink": "https://google-drive-clone-omega.vercel.app/",
    "githubLink": "https://github.com/SwarajAnand/GoogleDriveClone"
  },
  {
    "title": "FRONTEND - Group Chat App",
    "image": projectImage4,
    "description": "A Group Chat App built using React JS, JavaScript, Tailwind, MUI, and Firebase. This project enables real-time communication between multiple users, showcasing features such as user authentication, message storage, and responsive design.",
    "techstack": "React JS, JavaScript, Tailwind, MUI, Firebase",
    "previewLink": "https://ghost-all-chat-r26m.vercel.app/",
    "githubLink": "https://github.com/SwarajAnand/ghostAllChat"
  },
  {
    "title": "FRONTEND - Geekfood",
    "image": projectImage5,
    "description": "Geekfood is a web application built using React JS, Tailwind, and Axios. It features a user-friendly interface with multiple routes and makes API calls to fetch and display food-related data. Helped with learning React JS concepts",
    "techstack": "React JS, Tailwind, Axios",
    "previewLink": "https://g-food.vercel.app/",
    "githubLink": "https://github.com/SwarajAnand/gFood"
  },

];

// Enter your Contact Details here
export const contactDetails = {
  email: "swrjnnd@gmail.com",
  phone: "+91 8340683937",
};
